import { render, staticRenderFns } from "./CountedServiceTypeFilter.vue?vue&type=template&id=cbb24fea&"
import script from "./CountedServiceTypeFilter.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports